import React from 'react';
import { BonusCard } from './BonusCard';
const bonuses = [{
  number: 1,
  title: 'Listado Exclusivo de Proveedores',
  value: 14.99,
  description: 'Accede a un directorio completo de proveedores confiables de materias primas. Ahorra tiempo y dinero comprando en los lugares correctos desde el primer día.',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/imagen_2026-02-14_144226000_1.webp?v=1771076563'
}, {
  number: 2,
  title: 'Calculadora Inteligente de Ganancias™',
  value: 14.99,
  description: 'Costos claros. Márgenes seguros. Precios rentables desde el primer día.Introduce tus números y obtén el precio correcto sin adivinar.',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/20260302_1412_Calculadora_Ganancias_Femenina_simple_compose_01kjqat10pe578d235qgg7nv35_1.webp?v=1772459195'
}, {
  number: 3,
  title: 'Master de Marketing para Jabones™',
  value: 9.99,
  description: 'Clases Pre-grabadas. Estrategia clara. Posicionamiento sólido. Ventas con dirección. Más de 3 horas para aprender a atraer clientes y vender con seguridad.',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/image_43_1.webp?v=1772459365'
}, {
  number: 4,
  title: 'Maestría en Ventas por WhatsApp™',
  value: 17.99,
  description: 'Clases Pre-grabadas. Mensajes claros. Respuestas seguras. Cierres naturales. Aprende a convertir conversaciones en ventas reales sin presión.',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/20260302_1411_Curso_Ventas_WhatsApp_simple_compose_01kjqas183e8wss733f6q803ck_1_1.webp?v=1772459139'
}, {
  number: 5,
  title: 'Cosmética Sólida Profesional',
  value: 14.99,
  description: 'Shampoo sólido. Acondicionador sólido. Bálsamos. La tendencia ecológica que está explotando en ventas.',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/image_16_1.webp?v=1771013858'
}, {
  number: 6,
  title: 'Velas Artesanales Aromáticas',
  value: 14.99,
  description: 'Velas decorativas y aromáticas. El complemento perfecto para vender kits y combos. Más productos. Más ingresos.',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/imagen_2026-02-13_211851111_1.webp?v=1771013972'
}, {
  number: 7,
  title: 'Certificado de Reconocimiento',
  value: 17.99,
  description: 'Un certificado digital que avala tu formación. Perfecto para mostrar en redes y generar confianza.',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/image_18_1.webp?v=1771013999'
}, {
  number: 8,
  title: 'Membresía VIP',
  value: 17.99,
  description: 'Acceso de por Vida + Actualizaciones Gratuitas. Cada vez que agreguemos nuevas recetas o mejoras… Las recibes sin pagar un centavo extra. Sin renovaciones. Sin mensualidades. Sin letra pequeña.',
  imageUrl: 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/image_19_1.webp?v=1771014017'
}];
export function Bonuses() {
  return <section className="w-full bg-[var(--bg-dark)] py-8 md:py-12 px-4" data-id="element-65">
      <div className="max-w-6xl mx-auto" data-id="element-66">
        <div className="text-center mb-6 md:mb-10" data-id="element-67">
          <h2 className="text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-[var(--text-light)] mb-3 md:mb-4 leading-tight" data-id="element-68">
            No solo aprendes a hacer jabones…
            <br data-id="element-69" />
            <span className="text-[var(--accent-orange)]" data-id="element-70">
             Aprendes a convertirlos en ingresos reales
            </span>
          </h2>
          <p className="text-base md:text-xl lg:text-2xl text-[var(--text-gray)] max-w-3xl mx-auto leading-relaxed" data-id="element-71">
  
   con herramientas y formaciones diseñadas para ayudarte a vender desde casa.
  <span className="text-[var(--text-light)] font-bold" data-id="element-72">
    {' '}
    Estos son los bonos que recibirás hoy.
  </span>
        </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8" data-id="element-73">
          {bonuses.map(bonus => <BonusCard key={bonus.number} number={bonus.number} title={bonus.title} value={bonus.value} description={bonus.description} imageUrl={bonus.imageUrl} delay={0} data-id="element-74" />)}
        </div>

       
      </div>
    </section>;
}